// extracted by mini-css-extract-plugin
export default {"popup":"VideoPlayer_popup__oGPBC","card":"VideoPlayer_card__jDKHH","closeBtn":"VideoPlayer_closeBtn__h26ew"};